import { render, staticRenderFns } from "./EntityGrid.vue?vue&type=template&id=04efc815&scoped=true&"
import script from "./EntityGrid.vue?vue&type=script&lang=ts&"
export * from "./EntityGrid.vue?vue&type=script&lang=ts&"
import style0 from "./EntityGrid.vue?vue&type=style&index=0&id=04efc815&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04efc815",
  null
  
)

export default component.exports